import React from "react";
import { Typography, Divider, Tag } from "antd";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import { Button } from "../components/ui/button";
import {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
} from "../components/ui/tabs";

const { Title, Text, Paragraph } = Typography;

const Technology = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-b from-blue-300 to-indigo-100 py-16 pt-20 pb-10">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="flex-1">
              <Title level={1} className="mb-4">
                AI智能芯片技术
              </Title>
              <div className="text-gray-600 py-6 text-base">
                像科幻电影一样，给机器人插入芯片，即可激活智能意识
              </div>
              {/* <div className="flex gap-4 mt-2 mb-6">
                <Button variant="blue-griadient" size="lg">
                  了解更多
                </Button>
                <Button variant="secondary" size="lg">
                  联系我们
                </Button>
              </div> */}
            </div>
            <div className="md:w-1/2 max-w-[560px]">
              <img src={require("../assets/img/solution_hero.webp")} />
            </div>
          </div>
        </div>
      </section>

      {/* What is AI Chip Section */}
      <section
        className="py-24 md:pb-32 bg-white bg-center"
        style={{ backgroundImage: "url('/img/pattern-white.svg')" }}
      >
        <div className="container">
          <div className="md:max-w-5xl mb-12 mx-auto text-center">
            <span className="inline-block py-px px-2 mb-4 text-xs leading-5 text-blue-500 bg-blue-100  uppercase rounded-full shadow-sm">
              什么是AI智能芯片
            </span>
            <h2 className="mb-4 text-2xl md:text-3xl !leading-tight font-bold tracking-tight text-slate-800">
              机器人的智能核心
            </h2>
            <p className="text-base md:text-lg text-slate-500 mb-12">
              我们的AI智能芯片是一种集成了先进人工智能技术的微型处理器，就像科幻电影中那样，只需将芯片插入机器人，即可赋予其智能意识和学习能力。
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="p-8 bg-blue-50 rounded-lg">
                <h3 className="mb-2 text-lg font-bold text-slate-800">
                  微型化设计
                </h3>
                <p className="text-slate-600">
                  超小体积设计，可嵌入各种尺寸的机器人和智能设备中
                </p>
              </div>
              <div className="p-8 bg-blue-50 rounded-lg">
                <h3 className="mb-2 text-lg font-bold text-slate-800">
                  即插即用
                </h3>
                <p className="text-slate-600">
                  简单插入即可激活智能，无需复杂的编程和配置
                </p>
              </div>
              <div className="p-8 bg-blue-50 rounded-lg">
                <h3 className="mb-2 text-lg font-bold text-slate-800">
                  持续进化
                </h3>
                <p className="text-slate-600">
                  具备自主学习能力，随着使用不断提升智能水平
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Core Technology Points */}
      <section className="bg-gray-100 py-24 md:pb-32">
        <div className="container">
          <div className="md:max-w-5xl mb-12 mx-auto text-center">
            <span className="inline-block py-px px-2 mb-4 text-xs leading-5 text-blue-500 bg-blue-100  uppercase rounded-full shadow-sm">
              核心技术要点
            </span>
            <h2 className="mb-4 text-2xl md:text-3xl !leading-tight font-bold tracking-tight text-slate-800">
              突破传统的AI芯片技术
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="p-8 bg-white rounded-lg shadow-xl">
              <div className="flex items-center mb-6">
                <div className="inline-flex h-12 w-12 mr-4 items-center justify-center text-white bg-blue-600 rounded-lg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-slate-800">
                  先进的芯片架构
                </h3>
              </div>
              <p className="text-slate-600">
                采用异构计算架构，集成CPU、GPU、NPU等多种计算单元，专为AI任务优化，实现高效并行计算。
              </p>
            </div>
            <div className="p-8 bg-white rounded-lg shadow-xl">
              <div className="flex items-center mb-6">
                <div className="inline-flex h-12 w-12 mr-4 items-center justify-center text-white bg-blue-600 rounded-lg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-slate-800">
                  自主学习能力
                </h3>
              </div>
              <p className="text-slate-600">
                内置先进的强化学习算法，能够从环境中自主学习，不断优化行为模式，无需人工干预。
              </p>
            </div>
            <div className="p-8 bg-white rounded-lg shadow-xl">
              <div className="flex items-center mb-6">
                <div className="inline-flex h-12 w-12 mr-4 items-center justify-center text-white bg-blue-600 rounded-lg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-slate-800">
                  实时决策系统
                </h3>
              </div>
              <p className="text-slate-600">
                毫秒级响应速度，能够在复杂环境中实时分析、决策和执行，适应动态变化的场景。
              </p>
            </div>
            <div className="p-8 bg-white rounded-lg shadow-xl">
              <div className="flex items-center mb-6">
                <div className="inline-flex h-12 w-12 mr-4 items-center justify-center text-white bg-blue-600 rounded-lg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-slate-800">多设备兼容</h3>
              </div>
              <p className="text-slate-600">
                支持多种硬件平台，可适配不同类型的机器人和智能设备，实现统一的智能体验。
              </p>
            </div>
            <div className="p-8 bg-white rounded-lg shadow-xl">
              <div className="flex items-center mb-6">
                <div className="inline-flex h-12 w-12 mr-4 items-center justify-center text-white bg-blue-600 rounded-lg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-slate-800">
                  高级安全机制
                </h3>
              </div>
              <p className="text-slate-600">
                内置多层次安全防护系统，保障芯片运行安全，防止恶意攻击和数据泄露。
              </p>
            </div>
            <div className="p-8 bg-white rounded-lg shadow-xl">
              <div className="flex items-center mb-6">
                <div className="inline-flex h-12 w-12 mr-4 items-center justify-center text-white bg-blue-600 rounded-lg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-slate-800">低功耗设计</h3>
              </div>
              <p className="text-slate-600">
                优化的功耗管理系统，在保证高性能的同时，实现超长续航，适合各种移动机器人应用。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Technology Comparison */}
      <section className="relative py-24">
        <div
          className="absolute inset-0 bg-blue-600 bg-center bg-cover"
          style={{ backgroundImage: "url('/img/pattern-blue.svg')" }}
        ></div>
        <div className="relative container text-center text-white py-20 z-10">
          <div className="md:max-w-5xl mb-12 mx-auto">
            <h2 className="mb-4 text-2xl md:text-3xl !leading-tight font-bold tracking-tight">
              与传统AI技术对比
            </h2>
            <p className="text-base md:text-lg text-blue-100 mb-12">
              我们的AI智能芯片相比传统AI技术具有革命性的优势
            </p>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr className="border-b border-blue-500">
                  <th className="py-4 px-6 text-left">技术特性</th>
                  <th className="py-4 px-6 text-left">传统AI技术</th>
                  <th className="py-4 px-6 text-left">我们的AI智能芯片</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-blue-500/30">
                  <td className="py-4 px-6 font-medium">学习能力</td>
                  <td className="py-4 px-6">需要大量数据训练，无法自主学习</td>
                  <td className="py-4 px-6">自主学习，从环境中不断进化</td>
                </tr>
                <tr className="border-b border-blue-500/30">
                  <td className="py-4 px-6 font-medium">响应速度</td>
                  <td className="py-4 px-6">秒级响应，延迟高</td>
                  <td className="py-4 px-6">毫秒级响应，实时决策</td>
                </tr>
                <tr className="border-b border-blue-500/30">
                  <td className="py-4 px-6 font-medium">应用难度</td>
                  <td className="py-4 px-6">需要专业团队开发，复杂配置</td>
                  <td className="py-4 px-6">即插即用，无需复杂编程</td>
                </tr>
                <tr>
                  <td className="py-4 px-6 font-medium">适应性</td>
                  <td className="py-4 px-6">固定场景，无法适应变化</td>
                  <td className="py-4 px-6">动态适应，应对复杂环境</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Application Scenarios */}
      <section
        className="py-24 md:pb-32 bg-white bg-center"
        style={{ backgroundImage: "url('/img/pattern-white.svg')" }}
      >
        <div className="container">
          <div className="md:max-w-5xl mb-12 mx-auto text-center">
            <span className="inline-block py-px px-2 mb-4 text-xs leading-5 text-blue-500 bg-blue-100  uppercase rounded-full shadow-sm">
              应用场景
            </span>
            <h2 className="mb-4 text-2xl md:text-3xl !leading-tight font-bold tracking-tight text-slate-800">
              广泛的应用领域
            </h2>
            <p className="text-base md:text-lg text-slate-500 mb-12">
              我们的AI智能芯片可应用于各种机器人和智能设备，创造无限可能
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="p-8 bg-gray-50 rounded-lg shadow-md hover:shadow-xl transition-shadow">
              <div className="inline-flex h-12 w-12 mb-6 items-center justify-center text-white bg-blue-600 rounded-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                  />
                </svg>
              </div>
              <h3 className="mb-4 text-lg font-bold text-slate-800">
                服务机器人
              </h3>
              <p className="text-slate-600">
                应用于家庭服务机器人、酒店服务机器人、医疗辅助机器人等
              </p>
            </div>
            <div className="p-8 bg-gray-50 rounded-lg shadow-md hover:shadow-xl transition-shadow">
              <div className="inline-flex h-12 w-12 mb-6 items-center justify-center text-white bg-blue-600 rounded-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                  />
                </svg>
              </div>
              <h3 className="mb-4 text-lg font-bold text-slate-800">
                工业自动化
              </h3>
              <p className="text-slate-600">
                应用于工业机器人、自动化生产线、智能仓储系统等
              </p>
            </div>
            <div className="p-8 bg-gray-50 rounded-lg shadow-md hover:shadow-xl transition-shadow">
              <div className="inline-flex h-12 w-12 mb-6 items-center justify-center text-white bg-blue-600 rounded-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 10V3L4 14h7v7l9-11h-7z"
                  />
                </svg>
              </div>
              <h3 className="mb-4 text-lg font-bold text-slate-800">
                农业智能化
              </h3>
              <p className="text-slate-600">
                应用于农业机器人、智能灌溉系统、作物监测设备等
              </p>
            </div>
            <div className="p-8 bg-gray-50 rounded-lg shadow-md hover:shadow-xl transition-shadow">
              <div className="inline-flex h-12 w-12 mb-6 items-center justify-center text-white bg-blue-600 rounded-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
                  />
                </svg>
              </div>
              <h3 className="mb-4 text-lg font-bold text-slate-800">
                教育领域
              </h3>
              <p className="text-slate-600">
                应用于教育机器人、智能教学设备、编程学习工具等
              </p>
            </div>
            <div className="p-8 bg-gray-50 rounded-lg shadow-md hover:shadow-xl transition-shadow">
              <div className="inline-flex h-12 w-12 mb-6 items-center justify-center text-white bg-blue-600 rounded-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                  />
                </svg>
              </div>
              <h3 className="mb-4 text-lg font-bold text-slate-800">
                医疗健康
              </h3>
              <p className="text-slate-600">
                应用于医疗机器人、康复辅助设备、健康监测系统等
              </p>
            </div>
            <div className="p-8 bg-gray-50 rounded-lg shadow-md hover:shadow-xl transition-shadow">
              <div className="inline-flex h-12 w-12 mb-6 items-center justify-center text-white bg-blue-600 rounded-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"
                  />
                </svg>
              </div>
              <h3 className="mb-4 text-lg font-bold text-slate-800">
                智能家居
              </h3>
              <p className="text-slate-600">
                应用于智能家电、家庭机器人、智能家居控制系统等
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Development Platform */}
      <section className="py-24 bg-gray-100">
        <div className="container">
          <div className="md:max-w-5xl mb-12 mx-auto text-center">
            <span className="inline-block py-px px-2 mb-4 text-xs leading-5 text-blue-500 bg-blue-100  uppercase rounded-full shadow-sm">
              开发平台
            </span>
            <h2 className="mb-4 text-2xl md:text-3xl !leading-tight font-bold tracking-tight text-slate-800">
              简单易用的开发工具
            </h2>
            <p className="text-base md:text-lg text-slate-500 mb-12">
              我们提供完整的开发平台，帮助开发者快速构建基于AI智能芯片的应用
            </p>
          </div>
          <div className="flex flex-col md:flex-row gap-8 items-center">
            <div className="md:w-1/2">
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="inline-flex h-10 w-10 items-center justify-center text-white bg-blue-600 rounded-full flex-shrink-0 mt-1">
                    1
                  </div>
                  <div>
                    <h3 className="mb-2 text-lg font-bold text-slate-800">
                      可视化开发环境
                    </h3>
                    <p className="text-slate-600">
                      提供直观的可视化开发工具，无需复杂编程即可创建智能应用
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="inline-flex h-10 w-10 items-center justify-center text-white bg-blue-600 rounded-full flex-shrink-0 mt-1">
                    2
                  </div>
                  <div>
                    <h3 className="mb-2 text-lg font-bold text-slate-800">
                      丰富的API库
                    </h3>
                    <p className="text-slate-600">
                      提供全面的API和SDK，支持多种编程语言和开发框架
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="inline-flex h-10 w-10 items-center justify-center text-white bg-blue-600 rounded-full flex-shrink-0 mt-1">
                    3
                  </div>
                  <div>
                    <h3 className="mb-2 text-lg font-bold text-slate-800">
                      模拟测试工具
                    </h3>
                    <p className="text-slate-600">
                      内置模拟环境，可在开发阶段测试和优化AI应用
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="inline-flex h-10 w-10 items-center justify-center text-white bg-blue-600 rounded-full flex-shrink-0 mt-1">
                    4
                  </div>
                  <div>
                    <h3 className="mb-2 text-lg font-bold text-slate-800">
                      云端部署支持
                    </h3>
                    <p className="text-slate-600">
                      支持云端部署和远程管理，方便大规模应用部署
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="md:w-1/2">
              <img
                src={require("../assets/img/gaia.webp")}
                alt="开发平台"
                className="rounded-lg shadow-xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Future Vision */}
      <section
        className="py-24 md:pb-32 bg-white bg-center"
        style={{ backgroundImage: "url('/img/pattern-white.svg')" }}
      >
        <div className="container">
          <div className="md:max-w-5xl mb-12 mx-auto text-center">
            <span className="inline-block py-px px-2 mb-4 text-xs leading-5 text-blue-500 bg-blue-100  uppercase rounded-full shadow-sm">
              未来展望
            </span>
            <h2 className="mb-4 text-2xl md:text-3xl !leading-tight font-bold tracking-tight text-slate-800">
              推动AI技术的未来发展
            </h2>
            <p className="text-base md:text-lg text-slate-500 mb-12">
              我们将持续创新，不断提升AI智能芯片的性能和能力
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="p-8 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg shadow-md">
              <h3 className="mb-4 text-xl font-bold text-slate-800">
                更强大的智能
              </h3>
              <p className="text-slate-600">
                持续优化算法，实现更接近人类的智能水平，具备情感理解和创造力
              </p>
            </div>
            <div className="p-8 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg shadow-md">
              <h3 className="mb-4 text-xl font-bold text-slate-800">
                更小的体积
              </h3>
              <p className="text-slate-600">
                采用先进的制造工艺，进一步缩小芯片体积，可嵌入更小的设备中
              </p>
            </div>
            <div className="p-8 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg shadow-md">
              <h3 className="mb-4 text-xl font-bold text-slate-800">
                更低的功耗
              </h3>
              <p className="text-slate-600">
                优化功耗设计，实现超长续航，满足更多移动设备的需求
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Technology;
